import React, { Component } from "react";
import { connect } from "react-redux";
import { showError, showSuccess } from "ReduxErrorBar";
import _ from "lodash";
import {
  updateStripeAccount,
  deleteStripeAccount,
  openClientCardInfoModal,
} from "TicketAction";
import { confirmAlert } from "react-confirm-alert";
import {
  COMMON_FAIL_MESSAGE,
  STRIPE_CLIENTID,
  STRIPE_FEE,
  STRIPE_FEE_EXTRA,
  DEVELOPMENT_TYPE,
  STRIPE_CALLBACK_URI,
} from "Constants";
import CreditCardInfo from "./client-card-info";
import LocaleStrings from "Languages";

class Stripe extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, showStripBtn: true, stripe_user_id: "" };
  }

  componentDidMount() {
    var source =
      this.props.callfrom && this.props.callfrom == "wizard"
        ? this.props.callfrom
        : "payout";
    var url_string = window.location.href;
    var res = url_string.split("stripe_user_id=");

    if (res && res[1] && source == "payout") {
      this.setState({ showStripBtn: false, stripe_user_id: res[1] });
      this.updateStripeAccountData(res[1]);
    }

    var reser = url_string.split("error=");
    if (reser && reser[1] && source == "payout") {
      this.setState({ showStripBtn: true });
      this.props.showError(reser[1]);
    }
  }

  updateStripeAccountData(stripeaccountid) {
    this.props.updateStripeAccount(
      stripeaccountid,
      this.props.session,
      (response) => {
        if (response.success === 0) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.showSuccess("Stripe Details updated successfully!");
        }
      }
    );
  }

  disconnectStripe = () => {
    confirmAlert({
      title: "Disconnect",
      message:
        "Do you really want to disconnect Stripe? Your paid tickets will no longer be visible for sale!",
      confirmLabel: "Yes",
      cancelLabel: "No",
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteStripeAccount(this.props.session, (response) => {
              if (response.success === 0) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.showSuccess(
                  "Stripe Details Disconnected successfully!"
                );
              }
            });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  redirectUrl = (e) => {
    var source =
      this.props.callfrom && this.props.callfrom == "wizard"
        ? this.props.callfrom
        : "payout";
    var url = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENTID}&scope=read_write&state=${DEVELOPMENT_TYPE}_${source}&redirect_uri=${STRIPE_CALLBACK_URI}`;

    window.location.href = url;
  };

  openModal = (e) => {
    this.props.openClientCardInfoModal({ showModal: true });
  };
  updateCard = (e) => {
    this.props.openClientCardInfoModal({ showModal: true, update: "card" });
  };

  render() {
    let { ticketDashboard, clientCardInfoModal, SettingData } = this.props;
    var url = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENTID}&scope=read_write`;
    let StripeAccountData =
      this.props.StripeAccountData && this.props.StripeAccountData.resource
        ? this.props.StripeAccountData.resource
        : "";
    let displayAddBtn = true;
    let anotherPaymentGatwayConnected = false;
    let zarCurrCheck = _.filter(
      ticketDashboard ? ticketDashboard.currencies : [],
      (obj) => {
        return obj === "ZAR";
      }
    );

    if (zarCurrCheck.length > 0) {
      displayAddBtn = false;
    }

    if (
      ticketDashboard &&
      ticketDashboard.paymentgateway == true &&
      ticketDashboard.selectedpaymentgateway != "stripe"
    ) {
      anotherPaymentGatwayConnected = true;
    }

    return (
      <div className="stripe-tab" style={{ width: "60%" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading ticket-report-heading">
                {LocaleStrings.tickets_stripe_text_stripe_connect}
              </div>
              {anotherPaymentGatwayConnected === false ? (
                displayAddBtn == true ? (
                  <div className="panel-body">
                    <ul style={{ paddingLeft: 18, marginBottom: 15 }}>
                      <li>
                        {STRIPE_FEE}% + {STRIPE_FEE_EXTRA} /
                        {
                          LocaleStrings.tickets_stripe_text_ticket_processing_fee
                        }
                      </li>
                      <li>
                        {
                          LocaleStrings.tickets_stripe_text_seamless_checkout_experiance
                        }
                      </li>
                      <li>
                        {
                          LocaleStrings.tickets_stripe_text_you_must_have_stripe_account
                        }
                      </li>
                    </ul>
                    <div>
                      {StripeAccountData && StripeAccountData.length > 0 ? (
                        <a
                          className="btn"
                          onClick={this.disconnectStripe}
                          style={{
                            backgroundImage:
                              "linear-gradient(#28a0e5, #015e94)",
                            border: 0,
                            height: 32,
                            textDecoration: "none",
                            borderRadius: 5,
                            cursor: "pointer",
                            color: "white",
                          }}
                        >
                          Disconnect Stripe
                        </a>
                      ) : (
                        <a
                          onClick={this.redirectUrl}
                          className="connect-button"
                        >
                          {" "}
                          <img src="../../style/images/blue-on-dark.png" />
                        </a>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="panel-body">
                    {
                      LocaleStrings.tickets_stripe_allow_to_integrate_validation1
                    }
                  </div>
                )
              ) : (
                <div className="panel-body">
                  {LocaleStrings.tickets_stripe_allow_to_integrate_validation2}
                </div>
              )}
            </div>
          </div>
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="col-md-12">
              <div className="panel panel-default">
                <div className="panel-heading ticket-report-heading">
                  {LocaleStrings.tickets_credit_card_text_header}
                </div>
                {anotherPaymentGatwayConnected === false ? (
                  <div className="panel-body">
                    <ul style={{ paddingLeft: 18, marginBottom: 15 }}>
                      <li>{LocaleStrings.tickets_client_credit_card_text1}</li>
                    </ul>
                    <div>
                      {SettingData &&
                      SettingData.resource &&
                      SettingData.resource.length > 0 &&
                      SettingData.resource[0].stripecustomerid &&
                      SettingData.resource[0].stripecustomerid != "" &&
                      SettingData.resource[0].stripecustomercardid &&
                      SettingData.resource[0].stripecustomercardid != "" ? (
                        <button
                          onClick={this.updateCard}
                          className="btn btn-custom-blue"
                        >
                          {LocaleStrings.button_update_pg_card}
                        </button>
                      ) : (
                        <button
                          onClick={this.openModal}
                          className="btn btn-custom-blue"
                        >
                          {LocaleStrings.button_add_pg_info}
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="panel-body">
                    {
                      LocaleStrings.tickets_stripe_allow_to_integrate_validation3
                    }
                  </div>
                )}
              </div>
            </div>
          )}
          {clientCardInfoModal.showModal ? <CreditCardInfo /> : ""}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    StripeAccountData: state.StripeAccountData,
    ticketDashboard: state.ticketDashboard.data,
    SettingData: state.SettingData,
    clientCardInfoModal: state.clientCardInfoModal,
  };
}
export default connect(mapStateToProps, {
  updateStripeAccount,
  deleteStripeAccount,
  openClientCardInfoModal,
  showError,
  showSuccess,
})(Stripe);
